import mutations from "./mutations.js";
import actions from "./actions.js";
import getters from "./getters.js";

export default {
  namespaced: true,
  state() {
    return {
      summary: { branches: [], clients: [] },
      selectedEntity: null,
      entries: [],
      pagination: { page: 1, limit: 50, total: 0 },
      balance: {
        settled: 0, unsettledAccrual: 0, live: 0,
        unsettledBreakdown: {
          payinAmount: 0, payinCount: 0,
          payoutAmount: 0, payoutCount: 0,
          payinCommission: 0, payoutCommission: 0,
        },
        unsettledWindowStart: null,
      },
      categories: [],
    };
  },
  mutations,
  actions,
  getters,
};
